import { useState, useEffect, useCallback, useRef } from 'react';
import { CustomEditor } from 'slate/types/slate';

export function useTagTextDeleteWarning(editor: CustomEditor) {
  const [showWarning, setShowWarning] = useState(false);
  const dismissedTagIds = useRef(new Set<string>());
  const activeTagId = useRef<string | null>(null);

  useEffect(() => {
    editor.__onTagTextDeleted = (tagId: string) => {
      if (dismissedTagIds.current.has(tagId)) return;
      activeTagId.current = tagId;
      setShowWarning(true);
    };
    return () => {
      editor.__onTagTextDeleted = undefined;
    };
  }, [editor]);

  const handleConfirm = useCallback(() => {
    if (activeTagId.current) {
      dismissedTagIds.current.add(activeTagId.current);
    }
    activeTagId.current = null;
    setShowWarning(false);
  }, []);

  const handleRevert = useCallback(() => {
    activeTagId.current = null;
    editor.undo();
    setShowWarning(false);
  }, [editor]);

  return { showWarning, handleConfirm, handleRevert };
}
